import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useMutation } from 'react-query'
import { BrandVisualAnalysis } from 'types'

type BrandVisualAnalysisAttributes = {
  external_integration_id: number
}

type Data = BrandVisualAnalysis

type Variables = BrandVisualAnalysisAttributes

export const createBrandVisualAnalysis = async (
  workspaceId: number,
  attributes: BrandVisualAnalysisAttributes,
): Promise<BrandVisualAnalysis> => {
  const res = await sendToApi(`/w/${workspaceId}/brand_visual_analyses`, {
    method: 'POST',
    body: attributes,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.brand_visual_analysis
}

export const useCreateBrandVisualAnalysis = () => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>((vars) => createBrandVisualAnalysis(workspaceId, vars))
}
